import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-10"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-medium text-gray-900" }, "Preferences", -1)
const _hoisted_3 = { class: "text-sm mt-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-gray-900" }, "I would like Airport pick-up", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "(please send us flight details)", -1)
const _hoisted_6 = { class: "mt-6 flex text-sm text-gray-700 space-x-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, " We are pleased to provide you US$30 worth of 'Welcome Groceries' in your accommodation if requested. The service is free. The money charged covers the cost of the groceries. ", -1)
const _hoisted_8 = { class: "font-bold mt-10" }
const _hoisted_9 = { class: "mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-3 sm:gap-x-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "adults",
  class: "block text-sm font-medium text-gray-700"
}, "# Adults", -1)
const _hoisted_11 = { class: "mt-1" }
const _hoisted_12 = ["onChange"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "children",
  class: "block text-sm font-medium text-gray-700"
}, "# Children", -1)
const _hoisted_14 = { class: "mt-1" }
const _hoisted_15 = ["onChange"]
const _hoisted_16 = { class: "my-auto" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-gray-900" }, "Groceries", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "(US$30/TT$200)", -1)

import Toggle from "@/components/elements/Toggle.vue";
import { RoomTypes } from "api/_lib/types";

import { computed, reactive } from "vue";
import { roomDetails } from "@/lib/rooms";
import _ from "lodash";
import { InformationCircleIcon } from "@heroicons/vue/outline";
import {titleize} from "@/lib/bookings";

type RoomPreference = { label: string; type: RoomTypes; idx: number };


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingRoomPreferences',
  props: { roomSelected: { type: Object } },
  emits: ["updated"],
  setup(__props, { emit }) {

const props = __props;





const roomPreferences: {[key: string] : any} = reactive({});

const updatePreferences = (room: RoomPreference, input: string, value: string) => {
  _.set(roomPreferences, `${room.type}-${room.idx}.${input}`, value);
  // console.log(roomPreferences);
  emit("updated", roomPreferences);
};
const roomList = computed(() => {
  let items: Array<RoomPreference> = [];
  if (props.roomSelected)
    Object.keys(props.roomSelected).map((k) => {
      let qty = props.roomSelected?.[k];
      // console.log(props.roomSelected?.[k])
      if (qty > 0) {
        for (let i = 1; i <= qty; i++) {
          items.push({
            label:
              roomDetails[k as RoomTypes].type == "mainhouse"
                ? `${roomDetails[k as RoomTypes].category || ""}`
                : `${titleize(k)} #${i}`,
            type: roomDetails[k as RoomTypes].type as RoomTypes,
            idx: i,
          });
        }
      }
    });
  //   console.log(items)
  return items.filter((v) => !_.isNull(v));
});

return (_ctx: any,_cache: any) => {
  return (_unref(roomList).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Toggle, {
            onUpdated: _cache[0] || (_cache[0] = ($event: any) => (roomPreferences['_airportPickup'] = $event))
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(" ") + " "),
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(InformationCircleIcon), {
            class: "flex-shrink-0 h-5 w-5 text-gray-300",
            "aria-hidden": "true"
          }),
          _hoisted_7
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(roomList), (room, idx) => {
          return (_openBlock(), _createElementBlock("div", { key: idx }, [
            _createElementVNode("h2", _hoisted_8, _toDisplayString(room.label), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("input", {
                    onChange: ($event: any) => (updatePreferences(room, 'noAdults', $event.target.value)),
                    type: "number",
                    min: "0",
                    max: "4",
                    name: "adults",
                    class: "block w-full rounded-md border-gray-300 shadow-sm focus:border-teal-500 focus:ring-teal-500 sm:text-sm",
                    "aria-describedby": "adults-description"
                  }, null, 40, _hoisted_12)
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("input", {
                    onChange: ($event: any) => (updatePreferences(room, 'noChildren', $event.target.value)),
                    type: "number",
                    name: "children",
                    min: "0",
                    max: "4",
                    class: "block w-full rounded-md border-gray-300 shadow-sm focus:border-teal-500 focus:ring-teal-500 sm:text-sm",
                    "aria-describedby": "children-description"
                  }, null, 40, _hoisted_15)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(Toggle, {
                  onUpdated: ($event: any) => (updatePreferences(room,'groceries', $event))
                }, {
                  default: _withCtx(() => [
                    _hoisted_17,
                    _createTextVNode(" " + _toDisplayString(" ") + " "),
                    _hoisted_18
                  ]),
                  _: 2
                }, 1032, ["onUpdated"])
              ])
            ])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})